import Const from 'constants';

const defaultStateData = {inner: {}, outer: {}};

class State {
    data;
    constructor(data) {
        this.data = data;
    }
    hasBoundaries = () => !isEmpty(this.data.inner) && !isEmpty(this.data.outer);
    hasInnerMode = (mode) => this.data.inner.hasOwnProperty(mode);
    hasOuterMode = (mode) => this.data.outer.hasOwnProperty(mode);
    getInnerBoundaries = () => ({...this.data.inner});
    getInnerBoundary = (boundaryName, mode = Const.FLEX_MODE) => {
        if (this.hasInnerMode(mode) && this.data.inner[mode].hasOwnProperty(boundaryName)) {
            return Number(this.data.inner[mode][boundaryName]);
        }
        return null;
    };
    getOuterBoundary = (boundaryName, mode = Const.FLEX_MODE) => {
        if (this.hasOuterMode(mode) && this.data.outer[mode].hasOwnProperty(boundaryName)) {
            return Number(this.data.outer[mode][boundaryName]);
        }
        return null;
    };
    getInnerMin = (mode = Const.FLEX_MODE) => this.getInnerBoundary('min', mode);
    getInnerMax = (mode = Const.FLEX_MODE) => this.getInnerBoundary('max', mode);
    getOuterMin = (mode = Const.FLEX_MODE) => this.getOuterBoundary('min', mode);
    getOuterMax = (mode = Const.FLEX_MODE) => this.getOuterBoundary('max', mode);
    isInBoundaries = (value, mode = Const.FLEX_MODE) => {
        if (!this.hasInnerMode(mode)) {
            return true;
        }
        return this.getInnerMin(mode) <= value && this.getInnerMax(mode) >= value;
    };
}

const defaultState = new State(cp(defaultStateData));

export default function (state = defaultState, action) {
    state = {...state};

    if (action.type === Const.SALARY_BOUNDARY_SET_INNER) {
        const data = cp(state.data);
        Object.keys(action.items).map((mode) => {
            if (!state.hasInnerMode(mode)) {
                data.inner[mode] = cp(action.items[mode]);
                return;
            }
            // Avoid occasions when inner boundary can be out of outer.
            const {min = null, max = null} = action.items[mode];
            if (min !== null) {
                const outerMin = state.getOuterMin(mode);
                if (null !== outerMin && outerMin > min) {
                    data.inner[mode].min = outerMin;
                } else {
                    data.inner[mode].min = min;
                }
            }
            if (max !== null) {
                const outerMax = state.getOuterMax(mode);
                if (null !== outerMax && outerMax < max) {
                    data.inner[mode].max = outerMax;
                } else {
                    data.inner[mode].max = max;
                }
            }
        });
        state = new State(data);
    } else if (action.type === Const.SALARY_BOUNDARY_SET_OUTER) {
        const data = cp(state.data);
        // Set inner boundaries before updating outer.
        if (isEmpty(data.inner)) {
            data.inner = cp(action.items);
        } else {
            Object.keys(action.items).map((mode) => {
                if (!state.hasInnerMode(mode)) {
                    data.inner[mode] = cp(action.items[mode]);
                    return;
                }
                if (state.getOuterMin(mode) === state.getInnerMin(mode)) {
                    data.inner[mode].min = action.items[mode].min;
                }
                if (state.getOuterMax(mode) === state.getInnerMax(mode)) {
                    data.inner[mode].max = action.items[mode].max;
                }
            });
        }
        // Set outer boundaries.
        data.outer = {...data.outer, ...action.items};
        state = new State(data);
    } else if (inArray(action.type, [Const.RESET_ALL_SETTINGS, Const.FILTER_BY_SLATE])) {
        state = new State(cp(defaultStateData));
    }

    return state;
}
